var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"favorite",on:{"click":_vm.doFavor}},[_c('svg-icon',{class:{'favorite-icon': true, active: _vm.favorite},attrs:{"icon-class":"favorite"}}),_vm._v(" "+_vm._s(_vm.favorite ? '已收藏' : '未收藏')+" ")],1)}
var staticRenderFns = []

export { render, staticRenderFns }